module.exports = __webpack_public_path__ + "img/profile-woman-10-min.5e60dd31.jpg";